import React from 'react';

import { PromotionSectionCard } from './PromotionSectionCard';
import { Dropdown } from '../../component/Dropdown';
import { TextInput } from '../../component/TextInput';
import { countryOptions, currencyOptions } from '../../dropdownOptions';
import { Option, StatusOption } from '../../pages/types';
import { PROMOTION_NAME_PREFIX_REGEX } from '../../utils/promotionBuilders';

export function PromotionBasicsCard({
  promotionName,
  setPromotionName,
  isActive,
  isActiveOptions,
  setIsActive,
  currency,
  eligibleCountry,
  onCurrencyChange,
  onCountryChange,
}: {
  promotionName: string;
  setPromotionName: (v: string) => void;

  isActive: Option;
  isActiveOptions: Option[];
  setIsActive: (o: StatusOption) => void;

  currency?: Option;
  eligibleCountry?: Option;
  onCurrencyChange: (o: Option) => void;
  onCountryChange: (o: Option) => void;
}) {
  return (
    <PromotionSectionCard>
      <div className="text-md text-left">
        <div className="w-full mb-2">
          <h2>Promotion name</h2>
          <TextInput
            placeholder="YYYY-MM PROMOTION NAME (e.g., 2026-01 VALENTINES DAY)"
            value={promotionName}
            setTextChange={(v) => setPromotionName(v.toLocaleUpperCase())}
            error={
              promotionName.trim() && !PROMOTION_NAME_PREFIX_REGEX.test(promotionName)
                ? 'Name must start with YYYY-MM followed by a name (e.g., 2026-01 VALENTINES PUPGUM)'
                : undefined
            }
          />
        </div>
      </div>

      <div className="w-full mb-2">
        <div className="flex flex-row justify-between">
          <div className="flex-1 mr-4">
            <h2>Status</h2>
            <Dropdown
              options={isActiveOptions}
              selectedOption={isActive}
              setSelectedOption={setIsActive}
            />
          </div>
        </div>
      </div>

      <div className="flex">
        <div className="mb-2 mr-2 flex-1">
          <h2 className="mb-2">Currency</h2>
          <Dropdown
            noDefaultSelection
            options={currencyOptions}
            selectedOption={currency}
            setSelectedOption={onCurrencyChange}
          />
        </div>

        <div className="mb-2 mr-2 flex-1">
          <h2 className="mb-2">Eligible country</h2>
          <Dropdown
            noDefaultSelection
            options={countryOptions}
            selectedOption={eligibleCountry}
            setSelectedOption={onCountryChange}
          />
        </div>
      </div>
    </PromotionSectionCard>
  );
}
